import { computed, ref } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'
import Document from '@/components/Document/Document'
import { measureUnits } from '@/constants/measureUnits'
import { getCargoName } from '@/utils/trackGetters'

export default {
  name: 'TrackDocuments',
  components: { Document },
  setup(props, context) {
    const { $store } = context.root

    const docToUpload = ref(null)

    const track = computed(() => $store.state.driver.track)

    const getMeasureUnitTemplate = unit => measureUnits[unit]?.html || unit

    const loadFileRequest = useRequest({
      context,
      successMessage: 'Документ добавлен!',
      request: data => $store.dispatch('driver/createTrackDocument', data),
    })

    const addDocument = (id) => {
      context.refs[`fileInput_${id}`][0].$refs.input.click()
    }

    const loadDocument = async (pointId) => {
      const data = { name: 'ТТН', documentType: 'ТТН', file: docToUpload.value }
      await loadFileRequest.makeRequest({ pointId, data })
    }

    return {
      track,
      loadingFile: computed(() => loadFileRequest.loadingFile),
      docToUpload,
      addDocument,
      loadDocument,
      getMeasureUnitTemplate,
      getCargoName,
    }
  },
}
